import React, { useEffect, useState } from 'react';
import { simpleAuthGET } from '../api';
import {apiUrl} from '../api/apiConfig';
import { Link } from 'react-router-dom';
import '../App.css';
import { FORM_META } from '../components/form/constants';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import LoadingSpinner from 'components/loadingSpinner';

const DEFAULT_DESCENDING_SORT = false;

export default function Listing () {
    const [data, setData] = useState(null);
    const [sortBy, setSortBy] = useState({
        key: FORM_META.replyNeededDate.key,
        sortDescending: true
    });
    const [error, setError] = useState(null);

    // Fetch form data.
    useEffect(() => {
        const url = `${apiUrl}/api/rfi`;
        try {
            simpleAuthGET(url)
                .then(response => {
                    sortData(response, sortBy);
                    setError(null);
                });
        }
        catch (e) {
            console.error('error', e);
            setData([]);
            setError("An error occured fetching the RFIs. Try refreshing the page.");
        }
    }, []);

    let rfiList = (
        <h3 className="loading">
            <span>Loading</span>
            <span style={{paddingLeft: "10px"}}><LoadingSpinner /></span>
        </h3>
    );

    const columnHeaders = [
        FORM_META.rfiNumber,
        FORM_META.projectName,
        FORM_META.submissionDate,
        {
            ...FORM_META.replyNeededDate,
            label: 'Due Date'  
        },
        FORM_META.status,
    ];

    // handles clicking on a 
    const toggleSort = (newSort) => {
        if (newSort === sortBy.key) {
            setSortBy(state => {
                const newState = {...state, sortDescending: !state.sortDescending};
                sortData(data, newState);
                return newState;
            });
        }
        else {
            setSortBy(state => {
                const newState = {
                    key: newSort,
                    sortDescending: DEFAULT_DESCENDING_SORT
                };
                sortData(data, newState);
                return newState;
            });
        }
    };

    const sortData = (dataToSort, sortParameters) => {
        if (!dataToSort) {
            setData([]);
            return;
        }

        const sorted = [...dataToSort].sort((a, b) => {
            // strings need to be sorted with toLowerCase
            const value = typeof a[sortParameters.key] === 'string'
                ? a[sortParameters.key].toLowerCase() < b[sortParameters.key].toLowerCase() ? 1 : -1
                : a[sortParameters.key] < b[sortParameters.key] ? 1 : -1;
                
            // reverse sort is by descending
            return sortParameters.sortDescending ? value : -value;
        })
        setData(sorted);
    };

    if (error) {
        rfiList = (
            <div>{error}</div>
        )
    }

    if (data) {
        if (data.length < 1) {
            rfiList = (
                <div>
                    <h3>No RFIs Found</h3>
                </div>
            )
        }
        else {
            rfiList = (
                <table className="list">
                    <thead className="list-headers">
                        <tr>
                            {columnHeaders.map(header => {
                                const isSortBy = header?.key === sortBy.key;
                                return (
                                    <th
                                        key={header.label}>
                                            <div 
                                                onClick={() => toggleSort(header.key)}
                                                className={isSortBy ? 'selected-header-text' : 'header-text'}>
                                                <div className='header-label'>{header.label}</div>
                                                <div style={isSortBy ? {visibility: 'visible'} : {visibility: 'hidden'}}>{sortBy.sortDescending ? <FaArrowDown size={14}/> : <FaArrowUp size={14}/>}</div>
                                            </div>
                                    </th>
                                )
                            })}
                            <th style={{width: 50}}>Sent</th>
                        </tr>
                    </thead>
                    <tbody className="list-body">
                    {
                        data
                        .map(rfi => (                        
                            <tr key={rfi['rfi-id']} className="list-item">
                                <td className="column number">
                                    <Link className="link" to={`/rfi/${rfi['rfi-id']}`}>
                                        {rfi.rfiNumber}
                                    </Link>
                                </td>
                                <td className="column project-name">
                                    {rfi.projectName}
                                </td>
                                <td className="column date">
                                    {new Date(rfi.submissionDate).toLocaleDateString()}
                                </td>
                                <td className="column date">
                                    {new Date(rfi.replyNeededDate).toLocaleDateString()}
                                </td>
                                <td className="column status">
                                    {rfi.status}
                                </td>
                                <td className="column sent">
                                    {rfi.status === "Complete" && 
                                        <input 
                                            type="checkbox" 
                                            checked={true} 
                                            onChange={null} 
                                            readOnly={true}
                                            />
                                    }
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            );
        }
    }

    return (
        <div className="listing-container">
            <h2>RFI Listing</h2>
            {rfiList}
        </div>
    );
}